module.exports = __webpack_public_path__ + "admin/img/module_icon_puja.7c3dd468.svg";